import { z } from 'zod';
import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { CopilotJobTitleModelEntryNotConfiguredError } from 'libs/end-to-end/src/types/errors/copilot-job-title-model-entry-not-configured-error';

export const COPILOT_MODEL_DEFAULT_ALIAS = 'prod';

export const CopilotJobTitleModelEntry = z
  .object({
    jobTitleOrJobTitleGroup: z.string(),
    modelName: z.string().default(''),
    alias: z.string().default(COPILOT_MODEL_DEFAULT_ALIAS),
  })
  .describe('CopilotJobTitleModelEntry');

export type CopilotJobTitleModelEntry = z.infer<
  typeof CopilotJobTitleModelEntry
>;

/** Fail fast when a schedule entry is missing a registered model name. */
export const validateCopilotJobTitleModelEntryConfigured = (
  entry: CopilotJobTitleModelEntry,
): Result<void, CopilotJobTitleModelEntryNotConfiguredError> => {
  if (!entry.modelName.trim()) {
    return errResult({
      errorType: 'CopilotJobTitleModelEntryNotConfiguredError',
      jobTitleOrJobTitleGroup: entry.jobTitleOrJobTitleGroup,
      alias: entry.alias,
    });
  }

  return okResult(undefined);
};

export const CopilotModelByJobTitleConfig = z
  .object({
    usePretrainedModel: z.boolean().default(false),
    /** When true, each entry's jobTitle is a job title group; when false, a job title. Stored so we know which to use at runtime. */
    useJobTitleGroups: z.boolean().default(false),
    modelByJobTitle: z.array(CopilotJobTitleModelEntry).default([]),
  })
  .describe('CopilotModelByJobTitleConfig');

export type CopilotModelByJobTitleConfig = z.infer<
  typeof CopilotModelByJobTitleConfig
>;
